// Загрузка Lottie-анимаций из /icons/*.json (симлинк public/icons → static/icon_set) и перекраска в синий.

// Палитры перекраски: иконки должны звучать в гамме сайта, а не приносить свою.
const TONES = {
  brand:  { dark: [0.00, 0.18, 0.36], light: [0.62, 0.80, 0.98] },   // #002e5c → #9ecbfa
  onDark: { dark: [0.55, 0.72, 0.92], light: [1.00, 1.00, 1.00] },   // светлые — для синей шапки
  danger: { dark: [0.42, 0.05, 0.05], light: [0.99, 0.72, 0.72] },   // #6b0d0d → #fdb8b8
};

const cache = new Map();

export function loadAnimation(name) {
  if (!cache.has(name)) {
    cache.set(name, fetch(`/icons/${name}.json`).then((r) => {
      if (!r.ok) throw new Error(`icon ${name}: ${r.status}`);
      return r.json();
    }));
  }
  return cache.get(name);
}

function luminance([r, g, b]) {
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

// Любой цвет → оттенок выбранной палитры той же светлоты (монохромная перекраска).
export function toTone(rgb, tone = 'brand') {
  const { dark, light } = TONES[tone] || TONES.brand;
  const l = Math.min(1, Math.max(0, luminance(rgb)));
  return dark.map((d, i) => d + (light[i] - d) * l);
}

function recolorValue(k, tone) {
  if (Array.isArray(k) && k.length >= 3 && typeof k[0] === 'number') {
    const [r, g, b] = toTone(k.slice(0, 3), tone);
    return [r, g, b, ...k.slice(3)];
  }
  if (Array.isArray(k)) {
    // анимированный цвет: keyframes с полями s / e
    return k.map((kf) => (kf && typeof kf === 'object'
      ? { ...kf, ...(kf.s ? { s: recolorValue(kf.s, tone) } : {}), ...(kf.e ? { e: recolorValue(kf.e, tone) } : {}) }
      : kf));
  }
  return k;
}

function recolorGradient(g, tone) {
  // g.k.k = [t, r, g, b, t, r, g, b, ...]
  if (!g || !g.k || !Array.isArray(g.k.k)) return g;
  const arr = g.k.k.slice();
  for (let i = 0; i + 3 < arr.length; i += 4) {
    const [r, gg, b] = toTone([arr[i + 1], arr[i + 2], arr[i + 3]], tone);
    arr[i + 1] = r; arr[i + 2] = gg; arr[i + 3] = b;
  }
  return { ...g, k: { ...g.k, k: arr } };
}

export function recolorLottie(node, tone = 'brand') {
  if (Array.isArray(node)) return node.map((n) => recolorLottie(n, tone));
  if (!node || typeof node !== 'object') return node;
  const out = {};
  for (const [key, value] of Object.entries(node)) {
    if ((node.ty === 'fl' || node.ty === 'st') && key === 'c' && value && typeof value === 'object') {
      out[key] = { ...value, k: recolorValue(value.k, tone) };
    } else if (node.ty === 2 && key === 'v' && value && typeof value === 'object' && Array.isArray(value.k)) {
      // Цвет внутри эффекта (ty: 2 — color): такие группы «Base Color» / «Highlight»
      // перекрывают заливки слоя, поэтому их тоже нужно перекрашивать.
      out[key] = { ...value, k: recolorValue(value.k, tone) };
    } else if ((node.ty === 'gf' || node.ty === 'gs') && key === 'g') {
      out[key] = recolorGradient(value, tone);
    } else if (key === 'sc' && typeof value === 'string') {
      out[key] = value; // solid-слои оставляем
    } else {
      out[key] = recolorLottie(value, tone);
    }
  }
  return out;
}
